import RugCardDetailed from './RugCardDetailed'
export default RugCardDetailed
